import arrayMove from 'array-move';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useWorkspace, useActions } from '@mssgme/hooks';
import { SidebarHeader, ScrollableBox, NavBackButton } from '@mssgme/ui';
import { FieldTip } from '@mssgme/app/components/UI';
import { usePreview, PageLayout } from '../../../UI';
import SortableList from './SortableList';

import styles from './PageMessengers.scss';

export default function PageMessengers() {
    const workspace = useWorkspace();
    const actions = useActions();
    const { t } = useTranslation('cards');
    const { resetPreview } = usePreview();
    const [page_messengers, setPageMessengers] = useState(workspace.card.messengers);
    const [isFetching, setIsFetching] = useState(false);

    const leftButton = <NavBackButton to="/p/edit" />;

    async function onSortEnd({ oldIndex, newIndex }) {
        setPageMessengers(arrayMove(page_messengers, oldIndex, newIndex));
        setIsFetching(true);
        if (oldIndex !== newIndex) {
            const sorted = await actions.api.card.messengers.sort({ payload: { oldIndex, newIndex } });

            setPageMessengers(sorted);
            setIsFetching(false);
            resetPreview();
        }
    }

    return (
        <PageLayout>
            <SidebarHeader heading={t('pageMessengers.heading')} leftButton={leftButton} />
            <ScrollableBox>
                <SortableList
                    t={t}
                    messengers={page_messengers}
                    axis="y"
                    lockAxis="y"
                    onSortEnd={onSortEnd}
                    helperClass={styles.sortable}
                    isFetching={isFetching}
                    shouldCancelStart={(e) => {
                        if (e.target.dataset.element !== 'drag-handle') {
                            return true;
                        }
                    }}
                />
                <FieldTip>{t('FieldTip.messengers')}</FieldTip>
            </ScrollableBox>
        </PageLayout>
    );
}
